var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("USERS")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { lg: "3", sm: "6", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.adminValues,
                                  label: _vm.$t("users.admin")
                                },
                                model: {
                                  value: _vm.filter.admin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "admin", $$v)
                                  },
                                  expression: "filter.admin"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "3", sm: "6", cols: "12" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.agenciesItemsFilter,
                                  loading: _vm.agenciesFilter.isLoading,
                                  "search-input": _vm.agenciesFilter.search,
                                  "hide-no-data": "",
                                  "no-data-text": _vm.$t(
                                    "global.autocomplete.noDataFound"
                                  ),
                                  "item-text": "description",
                                  "item-value": "code",
                                  label: _vm.$t("users.agency"),
                                  placeholder: _vm.$t(
                                    "global.autocomplete.starTypingToSearch"
                                  ),
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.agenciesFilter.isEdit = true
                                  },
                                  change: function($event) {
                                    _vm.agenciesFilter.isEdit = false
                                  }
                                },
                                model: {
                                  value: _vm.filter.agencyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "agencyCode", $$v)
                                  },
                                  expression: "filter.agencyCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: { url: "/users", filter: this.filter }
                  }),
                  _vm.$checkPermission("USERS")
                    ? _c("ImportExcel", {
                        attrs: { url: "/users" },
                        on: { done: _vm.search }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.code }, [
                            _c(
                              "td",
                              [
                                _vm.$checkPermission("USERS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "orange",
                                        icon: "fa-pen",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.edit"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.edit(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                (item.deletionDate === undefined ||
                                  item.deletionDate === null) &&
                                _vm.$checkPermission("USERS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "red",
                                        icon: "fa-trash",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.delete"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.suspend(item.code)
                                        }
                                      }
                                    })
                                  : _vm.$checkPermission("USERS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "green",
                                        icon: "fa-redo",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.restore"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.restore(item.code)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$checkPermission("USERS")
                                  ? _c("crud-button", {
                                      attrs: {
                                        "x-small": "",
                                        color: "brown",
                                        icon: "fa-key",
                                        tooltip: _vm.$t(
                                          "global.crud.buttons.password"
                                        )
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.changePasswordDlg(
                                            item.code
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("td", [_vm._v(_vm._s(item.code))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(item.name) + " " + _vm._s(item.surname)
                              )
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(item.profile.description))
                            ]),
                            _c("td", [_vm._v(_vm._s(item.agencyCode))]),
                            _c(
                              "td",
                              [
                                _c("BooleanToIcon", {
                                  attrs: { value: item.admin }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialogPassword,
            callback: function($$v) {
              _vm.dialogPassword = $$v
            },
            expression: "dialogPassword"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { attrs: { color: "blue lighten-4" } }, [
                _c(
                  "span",
                  {
                    staticClass: "text-h5",
                    attrs: { color: "blue lighten-4" }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("global.profile.change.password")) +
                        " "
                    )
                  ]
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "password",
                                  label: _vm.$t(
                                    "global.profile.change.password.new"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "password",
                                  label: _vm.$t(
                                    "global.profile.change.password.confirm"
                                  ),
                                  required: ""
                                },
                                model: {
                                  value: _vm.passwordConfirm,
                                  callback: function($$v) {
                                    _vm.passwordConfirm = $$v
                                  },
                                  expression: "passwordConfirm"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.changePassword()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.confirm")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.closePsw()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("users.code"),
                                            rules: "required|max:200"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "users.code"
                                                        ),
                                                        rules: [
                                                          _vm.rules.email
                                                        ],
                                                        required: "",
                                                        "error-messages": errors,
                                                        disabled: _vm.editMode,
                                                        counter: "200"
                                                      },
                                                      model: {
                                                        value: _vm.item.code,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "code",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.code"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("users.name"),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "users.name"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      model: {
                                                        value: _vm.item.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.name"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("users.surname"),
                                            rules: "max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "users.surname"
                                                        ),
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      model: {
                                                        value: _vm.item.surname,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "surname",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.surname"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "users.datatable.profile"
                                            ),
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        items:
                                                          _vm.profilesItems,
                                                        loading:
                                                          _vm.profiles
                                                            .isLoading,
                                                        "search-input":
                                                          _vm.profiles.search,
                                                        "hide-no-data": "",
                                                        "no-data-text": _vm.$t(
                                                          "global.autocomplete.noDataFound"
                                                        ),
                                                        "item-text":
                                                          "description",
                                                        "item-value": "code",
                                                        label: _vm.$t(
                                                          "users.profile"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "global.autocomplete.starTypingToSearch"
                                                        ),
                                                        "error-messages": errors,
                                                        clearable: ""
                                                      },
                                                      on: {
                                                        "update:searchInput": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.profiles,
                                                            "search",
                                                            $event
                                                          )
                                                        },
                                                        "update:search-input": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.profiles,
                                                            "search",
                                                            $event
                                                          )
                                                        },
                                                        focus: function(
                                                          $event
                                                        ) {
                                                          _vm.profiles.isEdit = true
                                                        },
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.profiles.isEdit = false
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.profileCode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "profileCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.profileCode"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "users.datatable.agency"
                                            ),
                                            rules: "required"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        items:
                                                          _vm.agenciesItems,
                                                        loading:
                                                          _vm.agencies
                                                            .isLoading,
                                                        "search-input":
                                                          _vm.agencies.search,
                                                        "hide-no-data": "",
                                                        "no-data-text": _vm.$t(
                                                          "global.autocomplete.noDataFound"
                                                        ),
                                                        "item-text":
                                                          "description",
                                                        "item-value": "code",
                                                        label: _vm.$t(
                                                          "users.agency"
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "global.autocomplete.starTypingToSearch"
                                                        ),
                                                        "error-messages": errors,
                                                        clearable: ""
                                                      },
                                                      on: {
                                                        "update:searchInput": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.agencies,
                                                            "search",
                                                            $event
                                                          )
                                                        },
                                                        "update:search-input": function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            _vm.agencies,
                                                            "search",
                                                            $event
                                                          )
                                                        },
                                                        focus: function(
                                                          $event
                                                        ) {
                                                          _vm.agencies.isEdit = true
                                                        },
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.agencies.isEdit = false
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.agencyCode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "agencyCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.agencyCode"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("users.admin"),
                                            rules: "required|max:60"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "users.admin"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors
                                                      },
                                                      model: {
                                                        value: _vm.item.admin,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "admin",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.admin"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }